The name or code of the country subdivision.

For example, "VIC" for Victoria or "NSW" for New South Wales in Australia.
